<template>
  <div class="animated fadeIn">
    <Forms ref="frmProduct"
      :title="'CADASTRO DE PRODUTO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label><small v-show="form.codigo.required" class="text-danger">*</small> Código:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Código do Produto'"
                          v-model="form.codigo.value"
                          :size="form.codigo.maxlength"
                          :required="form.codigo.required"
                          :state="form.codigo.state"
                          autocomplete="false"></b-form-input>
          </div>
        </div>
        <div class="col-md-8">
          <label ><small v-if="form.nome.required" class="text-danger">*</small> Produto:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Nome do Produto'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import 'vue-select/dist/vue-select.css'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import ProductModel from '@/shared/models/configurations/productmodel.js'
import ProductForms from './product-form.js'
import ProductRepository from '@/shared/http/repositories/configurations/product.js'

export default {
  name: 'ProductAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: ProductModel,
      form: ProductForms
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      loading.pop()
    },
    onCreate () {
      loading.push()
      ProductRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      ProductRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/product/components/add/productadd.vue